<template>
    <div class="service-tel">
        <div class="service-tel-mask" v-if="showMask">
            <div class="popup_container">
                <div class="popup_title">
                    <div class="title_logo">
                      <img src="https://resource.rcclchina.com.cn/logo/PC/logoPopup.png" alt=""/>
                    </div>
                </div>
                <div class="popup_content">
                    <div class="popup_message">
                        <div>皇家官方预订专线：400-820-7195<br>服务时间：周一至周日 早9点-晚18点</div>
                    </div>
                    <div class="popup_panel">
                      <a class="popup_ok" @click="close">确定</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ServiceTel',
        props: {
            showMask: {
                type: Boolean,
                default: false
            }
        },
        methods: {
            close () {
                this.$emit('closeMask', false)
            }
        }
    }
</script>

<style lang="less" scoped>
    .service-tel{
        .service-tel-mask{
            position: fixed;
            left: 0;
            top: 0;
            z-index: 999;
            width: 100%;
            height: 100%;
            background-color: rgba(102,102,102,0.5);
            .popup_container{
                position: absolute;
                top: 92px;
                left: 50%;
                min-width: 420px;
                max-width: 420px;
                transform: translateX(-50%);
                -webkit-transform: translateX(-50%);
                -moz-transform: translateX(-50%);
                -o-transform: translateX(-50%);
                background: #FFF;
                font-size: 12px;
                color: #000;
                .popup_title{
                    font-size: 14px;
                    font-weight: bold;
                    text-align: center;
                    line-height: 1.75em;
                    color: #666;
                    cursor: default;
                    .title_logo{
                        width: 51px;
                        height: 50px;
                        margin: 15px auto 0;
                        & > img {
                          height: 100%;
                        }
                    }
                }
                .popup_content{
                    padding: 3em 1.75em 1em;
                    .popup_message{
                        max-height: 187px;
                        padding-bottom: 20px;
                        font-family: Arial, sans-serif;
                        text-align: center;
                        font-size: 12px;
                        line-height: 1.4;
                    }
                }
                .popup_panel{
                    margin: 16px auto;
                    text-align: center;
                    height: 30px;
                    width: auto;
                    .popup_ok{
                        font-size: 14px;
                        font-weight: bold;
                        width: 100px;
                        height: 30px;
                        background: url(https://resource.rcclchina.com.cn/content/taste/ships/QN/1-18.png);
                        margin-right: 6px;
                        text-align: center;
                        line-height: 30px;
                        color: #041555;
                        display: inline-block;
                        cursor: pointer;
                    }
                }
            }
        }
    }
</style>
